import { getAmplitudeInstance } from '../amplitudeHelpers';
import CardLocation from '../enums/CardLocation';
import MapLocation from '../enums/MapLocation';
import MapType from '../enums/MapType';
import NavigatedFrom from '../enums/NavigatedFrom';
import TrailPageType from '../enums/TrailPageType';

type logSaveClickedParams = {
  detailed_card_location?: CardLocation;
  inspirational_list_type?: string;
  map_id?: number;
  map_type: MapType;
  navigated_from?: NavigatedFrom;
  park_id?: string;
  save_location?: MapLocation;
  trail_id?: number;
  trail_page_type?: TrailPageType;
};

/**
 * A user clicks the save 'bookmark' icon to save a trail, prompting the list selection to pop-up.
 * @param params - Attributes to log with the amplitude event
 * @param params.detailed_card_location - Detailed location in the app where the save action occurred.
 * @param params.inspirational_list_type - List type of the page where save button is clicked (programmatic list, sponsored list, trail, etc,), passed from server
 * @param params.map_id - The id of the map (could be trail/activity/etc)
 * @param params.map_type - The type of map where the icon was clicked.
 * @param params.navigated_from - The location the user navigated from to get to this content
 * @param params.park_id - id of the park that the trail belongs to, if applicable, that was saved by the user
 * @param params.save_location - The screen on which the user was viewing an item when they clicked to save the map or trail to a list.
 * @param params.trail_id - The id of the trail
 * @param params.trail_page_type - Type of trail page where the save CTA was clicked
 */
const logSaveClicked = (
  {
    detailed_card_location,
    inspirational_list_type,
    map_id,
    map_type,
    navigated_from,
    park_id,
    save_location,
    trail_id,
    trail_page_type
  }: logSaveClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'save clicked',
    {
      'detailed card location': detailed_card_location,
      'inspirational list type': inspirational_list_type,
      'map id': map_id,
      'map type': map_type,
      'navigated from': navigated_from,
      'park id': park_id,
      'save location': save_location,
      'trail id': trail_id,
      'trail page type': trail_page_type
    },
    callback
  );
};

export default logSaveClicked;
